import React from 'react';

const SvgAu = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="AU_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="AU_svg__c">
        <stop stopColor="#FFF" offset="0%" />
        <stop stopColor="#F0F0F0" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="AU_svg__d">
        <stop stopColor="#FF2E3B" offset="0%" />
        <stop stopColor="#FC0D1B" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="AU_svg__b" fill="#fff">
        <use xlinkHref="#AU_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#AU_svg__a" />
      <path fill="#0A17A7" mask="url(#AU_svg__b)" d="M0 0h28v20H0z" />
      <path
        d="M4.333 4.153L-.9-.333H.667l.193.062L5.44 3h1.131l5.762-3.601v.934c0 .296-.17.627-.417.803l-4.25 3.036V5.18l4.3 3.685c.377.323.185.802-.3.802-.257 0-.588-.107-.804-.261L6.56 6.333H5.429L-.333 9.935v-1.44l4.666-3.333V4.153z"
        stroke="#FFF"
        strokeWidth={0.667}
        fill="#FF2E3B"
        mask="url(#AU_svg__b)"
      />
      <path
        d="M0 3.333V6h4.667v3.34c0 .364.306.66.673.66h1.32a.67.67 0 0 0 .673-.66V6h4.658a.677.677 0 0 0 .676-.673v-1.32a.674.674 0 0 0-.676-.674H7.333V0H4.667v3.333H0z"
        fill="url(#AU_svg__c)"
        mask="url(#AU_svg__b)"
      />
      <path
        fill="url(#AU_svg__d)"
        mask="url(#AU_svg__b)"
        d="M0 4h5.333V0h1.334v4H12v1.333H6.667v4H5.333v-4H0z"
      />
      <path
        fill="#FFF"
        mask="url(#AU_svg__b)"
        d="M6 16.333l-1.176.618.225-1.309-.951-.927 1.314-.19L6 13.332l.588 1.191 1.314.191-.95.927.224 1.31zM20 17.333l-.943.276.276-.942-.276-.943L20 16l.943-.276-.276.943.276.942zM20 4.667l-.943.276.276-.943-.276-.943.943.276.943-.276-.276.943.276.943zM24 8.667l-.943.276.276-.943-.276-.943.943.276.943-.276-.276.943.276.943zM16 10l-.943.276.276-.943-.276-.942.943.276.943-.276-.276.942.276.943zM22 11.667l-.471.138.138-.472-.138-.471L22 11l.471-.138-.138.471.138.472z"
      />
    </g>
  </svg>
);

export default SvgAu;
